import styled from "@emotion/styled"
import { docketTheme } from "theme"

interface ILabelProps {
  disabled?: boolean
  isFocused: boolean
  hasError: boolean
}

export const StyledLabel = styled.label<ILabelProps>`
  display: inline-block;
  color: ${({ theme, hasError, disabled, isFocused }) => {
    switch (true) {
      case hasError:
        return theme.palette.error.main
      case disabled:
        return theme.palette.grey[500]
      case isFocused:
        return theme.palette.primary.main
      default:
        return theme.palette.common.black
    }
  }};
  font-size: ${docketTheme.typography.fontSize_md};
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  line-height: 1.33;
`
